import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import HomeIcon from "@mui/icons-material/Home";
import WorkIcon from "@mui/icons-material/Work";
import Groups2Icon from "@mui/icons-material/Groups2";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SettingsIcon from "@mui/icons-material/Settings";
import LockPersonIcon from "@mui/icons-material/LockPerson";
import { IconButton, styled, useTheme } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useTranslation } from "react-i18next";

interface MenuProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const DrawerHeader = styled(IconButton)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: 8,
  justifyContent: "flex-end",
  left: 240,
  top: 90,
  background: "white",
  position: "fixed",
  zIndex: 3433232,
  borderRadius: "0 5px 5px 0",
  ":hover": {
    background: "white",
    cursor: "pointer",
  },
}));

const Menu = ({ open, setOpen }: MenuProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const DrawerList = (
    <Box sx={{ width: 240 }}>
      <List>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/">
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText primary={t("menu.home")} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/department">
            <ListItemIcon>
              <AccountBalanceIcon />
            </ListItemIcon>
            <ListItemText primary={t("menu.department")} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/positions">
            <ListItemIcon>
              <WorkIcon />
            </ListItemIcon>
            <ListItemText primary={t("menu.positions")} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/candidates">
            <ListItemIcon>
              <Groups2Icon />
            </ListItemIcon>
            <ListItemText primary={t("menu.candidates")} />
          </ListItemButton>
        </ListItem>
      </List>
      <Divider sx={{ borderColor: "divider" }} />
      <List>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/calendar">
            <ListItemIcon>
              <CalendarMonthIcon />
            </ListItemIcon>
            <ListItemText primary={t("menu.calendar")} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/reports">
            <ListItemIcon>
              <AssessmentIcon />
            </ListItemIcon>
            <ListItemText primary={t("menu.reports")} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/settings">
            <ListItemIcon>
              <SettingsIcon />
            </ListItemIcon>
            <ListItemText primary={t("menu.settings")} />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton component={Link} to="/administration">
            <ListItemIcon>
              <LockPersonIcon />
            </ListItemIcon>
            <ListItemText primary={t("menu.administration")} />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <Drawer
      open={open}
      variant="persistent"
      anchor="left"
      sx={{
        "& .MuiDrawer-paper": {
          maxHeight: "calc(100vh - 70px)",
          top: 80,
          border: "none",
          boxShadow: 3,
          zIndex: 300,
          width: 240,
        },
      }}
    >
      <DrawerHeader
        onClick={() => setOpen(false)}
        sx={{ boxShadow: "3px 0px 3px 0px rgba(0,0,0,0.3)" }}
      >
        {theme.direction === "ltr" ? <ChevronLeftIcon /> : <ChevronRightIcon />}
      </DrawerHeader>
      {DrawerList}
    </Drawer>
  );
};

export default Menu;
